module.exports = __webpack_public_path__ + "static/scopriabitareco_valori_1_sensibilita-0b920ac7d188cfd71cd7c086962f4a04.jpg";